/********************************************************************************
Filename: np-eula-popup.js
Created: 17 Jan 2023
Author: Ron Robertson
Description: A popup that requires users to accept the EULA before downloading
Usage Example:
<np-eula-popup></np-eula-popup>
********************************************************************************/

(function() {
    class NpEulaPopup extends HTMLElement {
        constructor() {
            /* Always call super first in constructor */
            super();

            this.eulaTriggers;
            this.modalEle;
            this.closeEle;
            this.hrefTarget;

        } /* END constructor */

        /* Called when added to DOM */
        connectedCallback() {

            // Gets all eula triggers based on className
            this.eulaTriggers = document.getElementsByClassName("eulaRequired");

            this.alterTriggers();

        } /* END connectedCallback */

        /* Listen for when attributes change */
        /* attributes must be lowercase */
        static get observedAttributes() {
            return ['modal-id', 'close-id'];
        }

      /* Called when attributes change */
      attributeChangedCallback(name, oldValue, newValue) {
        if(name === 'modal-id') {
            this.modalEle = document.getElementById(newValue);
        }
        if(name === 'close-id') {
            this.closeEle = document.getElementById(newValue);
        }

       }/* END attributesChangedCallback */

      /* Getting attributes */
      get modalId() {
        return this.getAttribute('modal-id');
      }
      get closeId() {
        return this.getAttribute('close-id');
      }

      /* Settinng attributes */
      set modalId(newValue) {
        this.setAttribute('modal-id', newValue);
      }
      set closeId(newValue) {
        this.setAttribute('close-id', newValue);
      }

        /* Method */

        // converts regular anchors to use the eula popup
        alterTriggers() {

            // Loop through all modal triggers and add click event to open the modal
            for (let i=0; i < this.eulaTriggers.length; i++){

                // hide href link in data-link property to prevent users bypassing the eula by right-clicking and selecting "save link as"
                this.eulaTriggers[i].setAttribute('data-link', this.eulaTriggers[i].getAttribute('href'));
                // removing href property
                this.eulaTriggers[i].setAttribute('href','');

                this.eulaTriggers[i].addEventListener("click", (e) => {
                    // prevent going to href target
                    e.preventDefault();

                    // Open Modal
                    this.pluginEULAModalOpen(e);
                })
            }
        }

        /* Open Modal */
        pluginEULAModalOpen = (e) => {
            document.documentElement.style.overflow = 'hidden';
            this.modalEle.open();


            //get href target from data-link property
            this.hrefTarget = e.target.closest('a').getAttribute('data-link');

            //Add Event trigger to accept checkbox
            document.getElementById(this.closeId).addEventListener('click', this.completeDownload, { once: true });

            //Add Event trigger to close button
            document.getElementById(this.modalId).addEventListener("modalClose", this.modalClose, { once: true });

        }

        modalClose = () => {
            //window.scrollTo(0, 0);

            /* Prevents double scrollbars when modal is displayed */
            document.documentElement.style.overflow = 'visible';
        }

        // Allow the user to download the file and close the modal
        completeDownload = () => {
            // downloads the file
            window.location = this.hrefTarget;

            //closes the modal
            this.modalEle.close();

            this.modalClose();

            //remove event listeners
            document.getElementById(this.closeId).removeEventListener('click', this.completeDownload, { once: true });
            document.getElementById(this.modalId).removeEventListener("modalClose", this.modalClose, { once: true });

            //uncheck accept in case EULA is needed again after 1 second
            setTimeout( () => this.closeEle.checked = false, 1000 );
        }

    } /* END class */

    window.customElements.define('np-eula-popup', NpEulaPopup);

  })();
